/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Event_Group_A_LabelInputs */



/**
* | output |
* | --- |
* | "Event Group A:" |
*
* @param {Compare_Event_Groups_Event_Group_A_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_event_group_a_label = /** @type {((inputs?: Compare_Event_Groups_Event_Group_A_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Event_Group_A_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe d'événements A :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltungsgruppe A:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di eventi A:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа мероприятий А:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de eventos A:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动组A：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループA:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट ग्रुप ए:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de Eventos A:")
	return /** @type {LocalizedString} */ ("Event Group A:")
});